<div class="viewer-container" [ngClass]="(this._vumeterDisplay === 'inside')? 'viewer-container-vumeter-inside' : ''">
  <div #divContainer class="viewer-canvas-container"
       [ngClass]="mouseDragging? 'cursor-drag':''"
       (drop)="this.onDrop($event)"
       (dragover)="this.allowDrop($event)"
       (mousedown)="this.onMouseDown($event)"
       (mouseup)="this.onMouseUp($event)"
       (touchstart)="this.onTouchStart($event)"
       (touchend)="this.onTouchEnd($event)"
       (dblclick)="this.onClickFullScreenToggleToggle()">
    <canvas #canvasAzz class="viewer-canvas" width="960" height="540"></canvas>
    <div class="justify-content-start align-items-center gap-3 output-control">
      <i [ngClass]="audioIcon" (click)="this.onClickAudioToggle()"></i>
      <i [ngClass]="isFullScreen === true? 'bi bi-fullscreen-exit':'bi bi-fullscreen'" (click)="this.onClickFullScreenToggleToggle()"></i>
    </div>
  </div>
</div>
